export var SUMMARY_OF_CARE_ALERT = {
    success: 'Summary of Care has been uploaded successfully.',
    error: 'Error uploading Summary of Care, please try again.',
};
export var PORTAL_INACTIVE_ERROR = 'Patient has not received an invitation to the Patient Portal';
export var EXPORT_IMMUNIZATION_INFO = "Some Immunization Registries require you to get consent from patients before you can share the data with the registries. Please check your Registry's requirements and make sure you have patient consent if needed.";
export var EXPORT_IMMUNIZATION_URL = '/EhrWebApp/patients/exportImmunizations.html?';
export var EXPORT_HEALTH_SURVEILLANCE_URL = '/EhrWebApp/patients/exportPatientHealth.html?';
export var EXPORT_REFERRAL_URL = '/EhrWebApp/patients/exportSummaryofcare.html?ccdaDocumentType=REFERRAL_NOTE&';
export var EXPORT_CONTINUITY_OF_CARE_URL = '/EhrWebApp/patients/exportSummaryofcare.html?ccdaDocumentType=CONTINUITY_OF_CARE&';
export var PATIENT_EDUCATION_URL = '/EhrWebApp/patients/patientEducation.html?';
export var MoreMenuTitles;
(function (MoreMenuTitles) {
    MoreMenuTitles["Secure"] = "Send Secure Message";
    MoreMenuTitles["Education"] = "Send Patient Education";
    MoreMenuTitles["Immunization"] = "Export Immunization Data";
    MoreMenuTitles["Surveillance"] = "Export Health Surveillance Data";
    MoreMenuTitles["Summary"] = "Import Summary of Care";
    MoreMenuTitles["Referral"] = "Export Referral";
    MoreMenuTitles["Continuity"] = "Export Continuity of Care";
})(MoreMenuTitles || (MoreMenuTitles = {}));
